"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalNotification = void 0;
const Theme_1 = require("../../Theme/Theme");
const Button_1 = require("../Button/Button");
const React = __importStar(require("react"));
const Container = Theme_1.styled.div `
  .leftElements {
    display: flex;
    align-items: center;
    padding-left: 20px;
  }

  .rightElements {
    display: flex;
    align-items: center;
  }

  display: flex;
  font-family: ${(props) => props.theme.font.family.proximaNova};
  font-weight: 100;
  font-size: 0.85em;
  justify-content: space-between;
  padding: 0px 0px 0px 0px;
  align-items: center;
  width: ${(props) => props.width || '100%'};
  height: 42px;
  border-radius: 25px;
  background: ${(props) => props.theme[getVariant(props.variant || '')]};
`;
const Icon = Theme_1.styled.div `
  background-color: ${(props) => props.theme[getIconColor(props.variant || 'notify')]};
  border-radius: 50px;
  width: 18px;
  height: 18px;
  margin-right: 10px;
  text-align: center;
  line-height: 1.4;
  color: ${(props) => props.theme.white};
  font-weight: 400;
`;
const Close = Theme_1.styled.div `
  font-family: ${(props) => props.theme.font.family.proximaNova};
  font-size: 0.8em;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  margin-right: 20px;
  text-align: center;
  line-height: 1.4;
  background-color: ${(props) => props.theme.gray2};
  color: ${(props) => props.theme.white};
  border-radius: 50px;
  font-weight: 400;
  cursor: pointer;
`;
exports.GlobalNotification = (props) => {
    return (React.createElement(Container, Object.assign({}, props), props.open && (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "leftElements" },
            React.createElement(Icon, { open: props.open, variant: props.variant }, getIcon(props.variant || 'notify')),
            props.children),
        React.createElement("div", { className: "rightElements" },
            React.createElement(Button_1.Button, { buttonStyle: "text", onClick: props.buttonAction }, props.buttonName),
            props.onClose && (React.createElement(Close, { open: props.open, onClick: props.onClose }, "X")))))));
};
function getIcon(variant) {
    if (variant === 'success') {
        return '✓';
    }
    else if (variant === 'error') {
        return '!';
    }
    return 'i';
}
function getIconColor(variant) {
    if (variant === 'success') {
        return 'green';
    }
    else if (variant === 'error') {
        return 'red';
    }
    return 'blue';
}
function getVariant(variant) {
    const success = 'lightGreen';
    const notify = 'lightBlue';
    const error = 'lightRed';
    switch (variant) {
        case 'success':
            return success;
        case 'notify':
            return notify;
        case 'error':
            return error;
        default:
            return notify;
    }
}
//# sourceMappingURL=GlobalNotification.js.map